/**
 * Detecta convite de chamada de vídeo / Meet na timeline do chat.
 */

function parseJsonMaybe(raw) {
  if (raw == null) return null;
  if (typeof raw === "object") return raw;
  if (typeof raw !== "string" || !raw.trim()) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function extractUrlFromButtonMessage(buttonMessage) {
  const raw = String(buttonMessage || "").trim();
  if (!raw) return null;
  const parts = raw.split(/[,;]/).map((p) => p.trim()).filter(Boolean);
  for (const part of parts) {
    for (const sep of ["|", "::"]) {
      const idx = part.indexOf(sep);
      if (idx > 0) {
        const label = part.slice(0, idx).trim();
        const url = part.slice(idx + sep.length).trim();
        if (/^https?:\/\//i.test(url)) {
          return { label: label || null, url };
        }
      }
    }
    if (/^https?:\/\//i.test(part)) {
      return { label: null, url: part };
    }
  }
  return null;
}

function firstHttpUrlInText(text) {
  const m = String(text || "").match(/https?:\/\/[^\s<>"')\]]+/i);
  return m ? m[0] : null;
}

function isVideoJoinUrl(url) {
  if (!url) return false;
  try {
    const u = new URL(url);
    return /\/video\//i.test(u.pathname);
  } catch {
    return /\/video\//i.test(String(url));
  }
}

function isMeetUrl(url) {
  if (!url) return false;
  try {
    return /meet\.google\.com/i.test(new URL(url).hostname);
  } catch {
    return /meet\.google\.com/i.test(String(url));
  }
}

/**
 * @returns {{
 *   kind: "video"|"meet",
 *   url: string,
 *   label: string|null,
 *   toolkit?: boolean,
 *   guestUrl?: string,
 *   agentUrl?: string,
 *   composeText?: string,
 *   requireCamera?: boolean,
 * } | null}
 */
export function resolveVideoInviteFromMessage(message) {
  if (!message) return null;
  const json =
    parseJsonMaybe(message.json_whatsapp) ||
    parseJsonMaybe(message.metadata) ||
    (message.metadata && typeof message.metadata === "object" ? message.metadata : null);
  const fromBtn = extractUrlFromButtonMessage(json?.buttonMessage);
  const fromInteractive =
    json?.interactive?.ctaUrl ||
    json?.interactiveOptions?.ctaUrl ||
    null;
  const textUrl = firstHttpUrlInText(
    message.text || message.mensagem || message.content || ""
  );
  const guestUrl = String(
    json?.guestJoinUrl || fromBtn?.url || fromInteractive || textUrl || ""
  ).trim();
  const agentUrl = String(json?.agentJoinUrl || guestUrl || "").trim();
  const url = (guestUrl || agentUrl).trim();
  if (!url) return null;

  const isToolkit = Boolean(json?.xpro_video_invite);
  const isAgentJoin = Boolean(json?.xpro_video_agent_join);
  const isTeamInvite = Boolean(json?.xpro_team_video_invite);

  if (isVideoJoinUrl(url) || isVideoJoinUrl(agentUrl)) {
    const inviteBody = String(json?.inviteBody || "").trim();
    const composeText = inviteBody
      ? `${inviteBody}\n${guestUrl || url}`
      : undefined;
    return {
      kind: "video",
      url: isAgentJoin || isTeamInvite ? agentUrl || url : guestUrl || url,
      label:
        fromBtn?.label ||
        json?.interactive?.ctaDisplayText ||
        json?.inviteCta ||
        null,
      toolkit: isToolkit && !isTeamInvite,
      guestUrl: guestUrl || url,
      agentUrl: agentUrl || url,
      composeText,
      teamInvite: isTeamInvite,
      requireCamera: Boolean(json?.requireCamera || json?.videoRequired),
    };
  }
  if (isMeetUrl(url)) {
    const text = String(message.text || message.mensagem || message.content || "");
    if (/meet|reuni[aã]o|google meet/i.test(text) || fromBtn || fromInteractive) {
      return {
        kind: "meet",
        url,
        label: fromBtn?.label || json?.interactive?.ctaDisplayText || null,
      };
    }
  }
  return null;
}

export function isVideoInviteMessage(message) {
  return Boolean(resolveVideoInviteFromMessage(message));
}
